/**
 * Portal Form is used for forms in Modal Windows
 * @param sFormId          the id of the form element
 * @param sSubView         the subview to submit to
 * @param sViewEngine      the view engine to use
 * @param oDefaultValues   the default values for form elements.
 *                         Keys are element IDs, Values are the default values.
 */
var PortalForm = function(sFormId, sSubView, sViewEngine, oDefaultValues) {
   if (!oDefaultValues) {
      oDefaultValue = {};
   }
    
   function submit(options) {
      var oParams = getQueryParameters();
      var aErrors = formValidator.updateErrors($(sFormId));
      if(aErrors.length !== 0) {
         return;
      }
      oParams.submitted = 'true';
      $("#ModalWindow").on("portalAjaxLoadEvent", emulateFormBehavior);
      modalWindows.submitModalWindowForm(sSubView, sViewEngine, $.param(oParams), options);
   }

   function cancel() {
      modalWindows.closeWindow();
   }
    
   function clear() {
      var jForm = $(sFormId);

      jForm.find("input").each(function() {
         var jInput = $(this),
            sType = jInput.attr("type"),
            sId = jInput.attr("id"),
            sAlt = jInput.attr("alt"),
            sDef = oDefaultValue[sId];

         if (!sDef) {
            sDef = sAlt;
         }

         if (sType == "text" || sType == "password" || sType == "email" || sType == "tel") {
            if (sDef) {
               jInput.val(sDef);
            } else {
               jInput.val("");
            }
         } else if (sType == "radio" || sType == "checkbox") {
            jInput.attr("checked", (sDef ? sDef : false));
         } else if (sType == "button" || sType == "submit" || sType == "hidden") {
         }
      });

      jForm.find("textarea, select").each(function() {
         var jInput = $(this),
            sId = jInput.attr("id"),
            sDef = oDefaultValue[sId];

         jInput.val(sDef);
      });
   }

   function emulateFormBehavior() {
      $("#ModalWindow").unbind("portalAjaxLoadEvent", emulateFormBehavior);

      var jForm = $(sFormId),
         bFirst = true;

      jForm.find("input, select").each(function() {
         var jInput = $(this),
            sType = jInput.attr("type")

         jInput.enter(submit);

         if (bFirst && sType != "hidden") {
            jInput.focus();
            bFirst = false;
         }
      });
   }
    
   function open(oParams) {
      $("#ModalWindow").on("portalAjaxLoadEvent", emulateFormBehavior);
      modalWindows.openModalWindow(sSubView, sViewEngine, oParams);
   }

   function getQueryParameters() {
      var aParams = {},
         jForm = $(sFormId);

      jForm.find("input").each(function() {
         var jInput = $(this),
            sType = jInput.attr("type"),
            sId = jInput.attr("id");

         if (sType == "text" || sType == "password" || sType == "hidden" || sType == "email" || sType == "tel") {
            aParams[sId] = jInput.val();
         } else if (sType == "radio") {
            if (jInput.prop("checked")) {
               aParams[jInput.attr("name")] = jInput.val();
            }
         } else if (sType == "checkbox") {
            if (jInput.attr("checked")) {
               aParams[sId] = jInput.val();
            }
         } else if (sType == "button" || sType == "submit") {
            // do nothing
         }
      });

      jForm.find("textarea, select").each(function() {
         var jInput = $(this),
            sId = jInput.attr("id");

         aParams[sId] = jInput.val();
      });

      return aParams;
   }

   return {
      load : open,
      open : open,
      getQueryParameters : getQueryParameters,
      submit : submit,
      clear : clear,
      cancel : cancel
   };
}
